module.exports = __webpack_public_path__ + "static/media/name.86b7662f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/name.jpg
// module id = 142
// module chunks = 0